import { Injectable, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';

import { TemplateHeadingApiModel } from '@app/api/api-models/templates/TemplateHeadingApiModel';
import { HttpClientService } from '@app/api/api-services/http-client.service';

@Injectable()
export class TemplateHeadingsService {
  public apiUrl = 'template-headings';

  public resetEmitter = new EventEmitter<void>();

  constructor(private readonly http: HttpClientService) {}

  public get(): Observable<Array<TemplateHeadingApiModel>> {
    return this.http.get<Array<TemplateHeadingApiModel>>(`${this.apiUrl}/get-list`);
  }

  public add(heading: TemplateHeadingApiModel): Observable<TemplateHeadingApiModel> {
    return this.http.post<TemplateHeadingApiModel>(`${this.apiUrl}/add`, heading).pipe((response) => {
      this.resetEmitter.emit();
      return response;
    });
  }

  public update(heading: TemplateHeadingApiModel): Observable<TemplateHeadingApiModel> {
    return this.http.put<TemplateHeadingApiModel>(`${this.apiUrl}/update`, heading).pipe((response) => {
      this.resetEmitter.emit();
      return response;
    });
  }

  public delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/delete/${id}`).pipe((response) => {
      this.resetEmitter.emit();
      return response;
    });
  }
}
